var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* eslint-disable */
// @ts-nocheck
import { disposeGeometryRecursively, buildPointLightGrid } from "@rendering/vortex-core";
import { Group, DefaultLoadingManager } from "three";
import { centerModel, findMeshRecursively, getSurfaceMapping } from "../common";
import { ColladaLoader } from "./colladaLoader";
export class ColladaProduct {
  constructor(config) {
    Object.defineProperty(this, "type", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "custom model"
    });
    Object.defineProperty(this, "modelUri", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "scene", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "meshGroup", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "rotationOffset", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "positionOffset", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "surfaceMapping", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "surfaceAliases", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.modelUri = config.modelUri;
    this.rotationOffset = config.rotationOffset;
    this.positionOffset = config.positionOffset;
    // set alias mapping for surfaces if there is any
    const aliases = {};
    // eslint-disable-next-line no-return-assign
    // @ts-ignore
    Object.entries(config.productMapping).map(_ref => {
      let [id, data] = _ref;
      return aliases[id] = data.alias;
    });
    this.surfaceAliases = aliases;
    // replace surfaceMapping ids with alias if exist
    const surfaceMap = {};
    Object.entries(getSurfaceMapping(config.productMapping, config.fullBleed)).forEach(_ref2 => {
      let [key, data] = _ref2;
      var _a;
      // @ts-ignore
      const id = (_a = aliases[key]) !== null && _a !== void 0 ? _a : key;
      surfaceMap[id] = data;
    });
    this.surfaceMapping = surfaceMap;
  }
  getGeometry() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.meshGroup) {
        return this.meshGroup;
      }
      yield this.preLoad();
      if (this.scene === undefined) {
        throw new Error("Failed to load model from uri");
      }
      this.meshGroup = new Group();
      this.meshGroup.add(this.scene);
      return centerModel(this.positionOffset, this.meshGroup);
    });
  }
  getSurfaceMapping() {
    return this.surfaceMapping;
  }
  setProductSurface(surfaceId, productSurface) {
    if (this.surfaceMapping[surfaceId]) {
      this.surfaceMapping[surfaceId] = Object.assign(Object.assign({}, this.surfaceMapping[surfaceId]), productSurface);
    } else {
      throw new Error("'".concat(surfaceId, "' is not a surface on this modeled product"));
    }
  }
  getAreaLights(pointLightIntensity, directionalLightIntensity) {
    const pointLightIntensities = [0.42 * pointLightIntensity, 0.42 * pointLightIntensity, 0.3885 * pointLightIntensity, 0.3885 * pointLightIntensity, 0.4515 * pointLightIntensity, 0.42 * pointLightIntensity];
    return buildPointLightGrid(pointLightIntensities);
  }
  getStates() {
    return [{
      id: "default"
    }];
  }
  setStates(_productState) {}
  getCurrentState() {
    return {
      id: "default"
    };
  }
  setCurrentState(_stateId) {}
  getAnimationIds() {
    return [];
  }
  buildAnimation(_animationOptions) {
    throw new Error("Method not implemented for Collda products.");
  }
  preLoad() {
    if (this.scene !== undefined) {
      return Promise.resolve();
    }
    const loader = new ColladaLoader(DefaultLoadingManager);
    return new Promise(resolve => {
      loader.load(this.modelUri, collada => {
        // If the collada model fails to load or has no scene
        if (!collada || !collada.scene) {
          resolve();
        }
        this.scene = collada.scene;
        // Apply rotation offsets before the model is re-sized
        if (this.rotationOffset) {
          collada.scene.rotation.set(this.rotationOffset.yaw, this.rotationOffset.pitch, this.rotationOffset.roll);
        }
        findMeshRecursively(this.scene, mesh => {
          var _a, _b;
          const id = (_a = this.surfaceAliases[mesh.uuid]) !== null && _a !== void 0 ? _a : mesh.uuid;
          // replace mesh uuid with alias if one exists
          mesh.uuid = id;
          // Clone and position a mesh to use for each finish
          if (this.surfaceMapping[id].finishes) {
            // @ts-ignore
            for (const finish of this.surfaceMapping[id].finishes) {
              const clone = mesh.clone();
              clone.geometry = mesh.geometry.clone();
              // Update the name for the finish
              clone.uuid = "".concat(id, "-").concat(finish.name);
              clone.name = "".concat(id, "-").concat(finish.name);
              // Link the mesh to it's parent
              clone.parent = mesh.parent;
              (_b = mesh.parent) === null || _b === void 0 ? void 0 : _b.children.push(clone);
            }
          }
        });
        resolve();
      });
    });
  }
  dispose() {
    // TODO handle disposal correctly
    this.scene && disposeGeometryRecursively(this.scene);
    this.scene = undefined;
    this.meshGroup = undefined;
  }
}